import React from 'react';
import { Link } from 'react-router-dom';
import css from './Footer.css';

const BottomLinks = () => (
    <>
        <li className={css.listItem} key="impressum">
            <Link to="/impressum" className={css.link}>
                Impressum
            </Link>
        </li>
        <li className={css.listItem} key="datenschutz">
            <Link to="/datenschutz" className={css.link}>
                Datenschutz
            </Link>
        </li>
        <li className={css.listItem} key="cookie">
            <span
                onClick={() => {
                    const UC_UI_defined = typeof window !== 'undefined' && window.UC_UI;

                    UC_UI_defined && window.UC_UI.showSecondLayer();
                }}
                className={css.link}
            >
                Cookie-Einstellungen
            </span>
        </li>
        <li className={css.listItem} key="agb">
            <Link to="/agb" className={css.link}>
                AGB
            </Link>
        </li>
    </>
);

export default BottomLinks;
